// Copyright (c) 2017 Deere & Company

import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {getStore} from '../../store-factory';

export const getUser = () => new User(getStore().getState().user.details);




// WEBPACK FOOTER //
// ./src/shared/services/get-user.js